/**
 * Log/Report
 * 현재 상태
 * SD-WAN 터널 상태
 * 토폴로지 상태 Store
 *
 * @since 2022-12-09
 * @author wj_tams_dev01
 */
export const state = () => ({
  topologyNormalGroupList: [], // 이상 그룹 전체 리스트
  topologyAbnormalGroupList: [], // 정상 그룹 전체 리스트
  topologyNodeList: [], // 그룹 당 장비(Edge) 리스트 (최대 100개)
  topologyLinkList: [], // 그룹 당 링크(Link) 리스트 (최대 4,950개) - 중복 제거
  deviceLinkList: [], // 장비 당 링크(Link) 리스트 (최대 99개) - 중복 제거
  deviceDetailLinkList: [], // 장비 팝업 - 터널 상태 리스트 (최대 99 X 16개)
  detailLinkList: [] // 링크 세부정보 리스트 (최대 16개) - 중복 허용
})

export const mutations = {
  initTopologyStore (state) {
    state.topologyNormalGroupList = Object.freeze([])
    state.topologyAbnormalGroupList = Object.freeze([])
    state.topologyNodeList = Object.freeze([])
    state.topologyLinkList = Object.freeze([])
    state.deviceLinkList = Object.freeze([])
    state.detailLinkList = Object.freeze([])
  },
  setTopologyGroupList (state, groupListObj) {
    if (!_.isPlainObject(groupListObj)) {
      state.topologyNormalGroupList = Object.freeze([])
      state.topologyAbnormalGroupList = Object.freeze([])
      return
    }
    if (_.isArray(groupListObj.abnormal_grp_list)) {
      state.topologyAbnormalGroupList = Object.freeze(_.cloneDeep(groupListObj.abnormal_grp_list))
    } else {
      state.topologyAbnormalGroupList = Object.freeze([])
    }
    if (_.isArray(groupListObj.normal_grp_list)) {
      state.topologyNormalGroupList = Object.freeze(_.cloneDeep(groupListObj.normal_grp_list))
    } else {
      state.topologyNormalGroupList = Object.freeze([])
    }
  },
  setTopologyNodeList (state, nodeListObj) {
    if (!_.isPlainObject(nodeListObj) || !_.isArray(nodeListObj.nodes)) {
      return
    }
    const convertedNodeList = []
    nodeListObj.nodes.forEach((node) => {
      convertedNodeList.push({
        id: node.id.toString(),
        name: node.name,
        device_type: node.device_type,
        device_ip: node.device_ip
      })
    })
    state.topologyNodeList = Object.freeze(_.cloneDeep(convertedNodeList))
  },
  setTopologyLinkList (state, linkListObj) {
    if (!_.isPlainObject(linkListObj) || !_.isArray(linkListObj.links)) {
      // state.topologyLinkList = Object.freeze([])
      return
    }
    const convertedLinkList = []
    linkListObj.links.forEach((link) => {
      if (link.sdwan_tnl_status !== 1) {
        convertedLinkList.push({
          id: link.source + '_' + link.target,
          source: link.source.toString(),
          target: link.target.toString(),
          sdwan_tnl_status: link.sdwan_tnl_status,
          curve: 0.0
        })
      }
    })
    state.topologyLinkList = Object.freeze(_.cloneDeep(convertedLinkList))
  },
  setDeviceLinkList (state, linkListObj) {
    if (!_.isPlainObject(linkListObj) || !_.isArray(linkListObj.links)) {
      return
    }
    let linkSource = null, linkTarget = null
    const convertedLinkList = []
    linkListObj.links.forEach((link) => {
      linkSource = link.source.toString()
      linkTarget = link.target.toString()
      convertedLinkList.push({
        id: linkSource + '_' + linkTarget,
        source: linkSource,
        target: linkTarget,
        sdwan_tnl_status: link.sdwan_tnl_status,
        curve: 0.0
      })
    })
    state.deviceLinkList = Object.freeze(_.cloneDeep(convertedLinkList))
  },
  setDetailLinkList (state, linkDetailObj) {
    if (!_.isPlainObject(linkDetailObj) || !_.isArray(linkDetailObj.tnl_detail)) {
      // state.detailLinkList = Object.freeze([])
      return
    }
    let linkSource = null, linkTarget = null
    const convertedLinkList = []
    let linkCurveValue = 0
    linkDetailObj.tnl_detail.forEach((link, index) => {
      linkSource = link.source.toString()
      linkTarget = link.target.toString()
      linkCurveValue = 0.05 + (0.1 * _.parseInt(index / 2))
      convertedLinkList.push({
        id: linkSource + '_' + linkTarget + '_' + index,
        source: linkSource,
        target: linkTarget,
        source_ip: link.source_ip,
        target_ip: link.target_ip,
        tnl_name: link.tnl_name,
        sdwan_path_label_name: link.sdwan_path_label_name,
        sdwan_path_label_color: (_.isUndefined(link.sdwan_path_label_color) ? '' : link.sdwan_path_label_color),
        sdwan_path_label_type: link.sdwan_path_label_type,
        cfg_dt: link.cfg_dt,
        sdwan_tnl_id: link.sdwan_tnl_id,
        sdwan_tnl_status: link.sdwan_tnl_status,
        curve: ((index % 2 === 0) ? linkCurveValue : -linkCurveValue)
      })
    })
    state.detailLinkList = Object.freeze(_.cloneDeep(convertedLinkList))
  },
  setDeviceTunnelStatusList (state, linkStatusObj) {
    if (!_.isPlainObject(linkStatusObj) || !_.isArray(linkStatusObj.tnl_status)) {
      state.deviceDetailLinkList = Object.freeze([])
      return
    }
    const convertedLinkList = []
    linkStatusObj.tnl_status.forEach((link) => {
      convertedLinkList.push({
        local_device_uname: link.local_device_uname,
        local_ip_address: link.local_ip_address,
        remote_device_uname: link.remote_device_uname,
        remote_ip_address: link.remote_ip_address,
        sdwan_path_label_name: link.sdwan_path_label_name,
        cfg_dt: link.cfg_dt,
        sdwan_tnl_status: link.sdwan_tnl_status
      })
    })
    // 이상 터널을 테이블의 가장 최상위로 배치한다. ( 4 -> 3 -> 2 -> 1 )
    convertedLinkList.sort((a, b) => {
      if (a.sdwan_tnl_status > b.sdwan_tnl_status) {
        return -1
      } else if (a.sdwan_tnl_status < b.sdwan_tnl_status) {
        return 1
      }
      return 0
    })
    state.deviceDetailLinkList = Object.freeze(_.cloneDeep(convertedLinkList))
  }
}
export const actions = {
  async getTopologyGroupList ({ state, commit }) {
    // Axios 호출
    const apiUrl = `/api/lr/sdwan/topology/tnl_grp_list`

    const res = await this.$axios.$get(apiUrl, {
      loading: false,
      successAlert: false
    })

    // 호출된 데이터 확인
    if (res.code === 'ok') {
      commit('setTopologyGroupList', res.result)
    }

    return res
  },
  async getTopologyNodeList ({ state, commit }, {param}) {
    // Axios 호출
    const apiUrl = `/api/lr/sdwan/topology/device_list/${param.sdwan_tnl_grp_id}`

    const res = await this.$axios.$get(apiUrl, {
      loading: false,
      successAlert: false
    })

    // 호출된 데이터 확인
    if (res.code === 'ok') {
      commit('setTopologyNodeList', res.result)
    }

    return res
  },
  async getTopologyLinkList ({ state, commit }, {param}) {
    // Axios 호출
    const apiUrl = `/api/lr/sdwan/topology/tnl_list/${param.sdwan_tnl_grp_id}`

    const res = await this.$axios.$get(apiUrl, {
      loading: false,
      successAlert: false
    })

    // 호출된 데이터 확인
    if (res.code === 'ok') {
      commit('setTopologyLinkList', res.result)
    }

    return res
  },
  async getDeviceLinkList ({ state, commit }, {param}) {
    // Axios 호출
    const apiUrl = `/api/lr/sdwan/topology/device_view/${param.sdwan_tnl_grp_id}/${param.device_id}`

    const res = await this.$axios.$get(apiUrl, {
      loading: false,
      successAlert: false
    })

    // 호출된 데이터 확인
    if (res.code === 'ok') {
      commit('setDeviceLinkList', res.result)
    }

    return res
  },
  async getDetailLinkList ({ state, commit }, {param}) {
    // Axios 호출
    const apiUrl = `/api/lr/sdwan/topology/tnl_detail/${param.sdwan_tnl_grp_id}/${param.source}/${param.target}`

    const res = await this.$axios.$get(apiUrl, {
      loading: false,
      successAlert: false
    })

    // 호출된 데이터 확인
    if (res.code === 'ok') {
      commit('setDetailLinkList', res.result)
    }

    return res
  },
  async getDeviceTunnelStatusList ({ state, commit }, {param}) {
    // Axios 호출
    const apiUrl = `/api/lr/sdwan/topology/device_tnl_status/${param.sdwan_tnl_grp_id}/${param.device_id}`

    const res = await this.$axios.$get(apiUrl, {
      loading: true,
      successAlert: false
    })

    // 호출된 데이터 확인
    if (res.code === 'ok') {
      commit('setDeviceTunnelStatusList', res.result)
    }

    return res
  }
}

export const getters = {}
export const strict = false
